import React, { useState } from "react";

const ResetLocalStorageButton = () => {
  const [buttonStyle, setButtonStyle] = useState({
    fontFamily: "Roboto, sans-serif",
    fontSize: "12px",
    lineHeight: "20px",
    textAlign: "center",
    color: "#ffffff",
    background: "#d9534f", // Red background color, you can change this
    border: "1px solid #d9534f", // Red border color, you can change this
    borderRadius: "4px",
    padding: "4px 10px",
    cursor: "pointer",
    transition: "background 0.3s ease-in-out, color 0.3s ease-in-out"
  });

  const handleResetLocalStorage = () => {
    const shouldReset = window.confirm("Are you sure you want to reset the application? This will also leave the page.");
    if (shouldReset) {
      
      window.location.reload();
     localStorage.clear();
      // You can also perform additional actions after clearing local storage if needed
      console.log("Local storage reset!");
    }
  };

  return (
    <button
      style={buttonStyle}
      onClick={handleResetLocalStorage}
      onMouseOver={() => {
        setButtonStyle({
          ...buttonStyle,
          background: "#c9302c", // Darker red on hover
          borderColor: "#c9302c"
        });
      }}
      onMouseOut={() => {
        setButtonStyle({
          ...buttonStyle,
          background: "#d9534f",
          borderColor: "#d9534f"
        });
      }}
    >
      Reset Application
    </button>
  );
};

export default ResetLocalStorageButton;
